import BaseService from "@/services/BaseService";
import User from "@/types/User";

export default class UserService extends BaseService {
    static async getUsers(page: number, organizationId: string | null, pagination: boolean = true, filter?: string) {
        return await this.perform<{ count: number, pages: number, items: User[] }>({
            url: `/portal/users?page=${page.toString()}${organizationId === null ? "" : "&organizationId=" + organizationId}&pagination=${pagination}${filter ? `&filter=${filter}` : ""}`,
            method: "GET",
            auth: true
        });
    }

    static async deleteUser(user: User) {
        return await this.perform<User>({
            url: "/portal/users/" + user.id,
            method: "DELETE",
            auth: true
        });
    }

    static async resetTermsAndConditions() {
        return await this.perform<User>({
            url: "/portal/users",
            method: "PUT",
            auth: true
        });
    }

    static async generateInvitation(fiscalCode: string, organizationId: string) {
        return await this.perform<string>({
            url: "/portal/users/generate-invitation?export=link&cf=" + fiscalCode + "&organizationId=" + organizationId,
            method: "GET",
            auth: true
        });

        /*
        const response = await axios({
            url: process.env.VUE_APP_HOST + "/api/portal/users/generate-invitation?export=pdf&cf=" + fiscalCode + "&organizationId=" + organizationId,
            method: 'GET',
            responseType: 'blob',
            headers: {
                "Authorization": `Basic ${sessionStorage.getItem("access-token")}`
            }
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));

        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        
        fileLink.setAttribute('download', fiscalCode.toUpperCase() + ".pdf");
        
        document.body.appendChild(fileLink);
        fileLink.click();
        
        document.body.removeChild(fileLink);
        */
    }
}